/**
 * Utilities for handling label fields on playbook records (e.g. `sys_pd_activity.label`).
 *
 * The platform's "Strip HTML from label" Business Rule
 * (sys_script_de69da9241f33010f8773a54b5d2b3a3 for sys_pd_activity,
 * sys_script_3bc093588db37010f877b791d05ecce4 for sys_pd_activity_definition)
 * silently strips HTML on insert/update. The Fluent build pipeline mirrors that
 * behavior so labels persisted via Fluent match what the platform would produce.
 */

/**
 * Detects any HTML tag (open, close, or self-closing) in a string.
 * Mirrors the platform BR regex.
 */
export const HTML_TAG_REGEX = /<\/?[^>]+(>|$)/

/**
 * Strips all HTML tags from a string. Mirrors the platform BR behavior so the
 * label persisted via Fluent matches what the platform would produce on
 * insert/update.
 */
export function stripHtmlTags(value: string): string {
    return value.replace(/<\/?[^>]+(>|$)/g, '')
}
